import { render } from "./LocationLeadership.vue?vue&type=template&id=183b41a6"
import script from "./LocationLeadership.vue?vue&type=script&lang=js"
export * from "./LocationLeadership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__